import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );
  useEffect(() => {
    const checkAccessToken = () => {
      const accessToken = localStorage.getItem("accessToken");
      if (accessToken) {
        setAccessToken(accessToken);
      }
    };
    window.addEventListener("storage", checkAccessToken);

    return () => {
      window.removeEventListener("storage", checkAccessToken);
    };
  }, []);
  return accessToken ? children : <Navigate to={"/signin"} />;
};

export default RequireAuth;
